@if (!sliderWithLabelAside) {
  <div class="custom-rangeslider custom-rangeslider--lg">
    <div class="custom-rangeslider__control" [id]="'slider' + index"></div>
    <div class="custom-rangeslider__input">
      <input class="form-control"
        type="text"
        [readonly]="readonly"
        [id]="'sliderinput' + index"
        (change)="onInputChange($event)">
      </div>
    </div>
  }

  @if (sliderWithLabelAside) {
    <div class="custom-slider">
      <div class="custom-slider__input">
        <h6>{{labelText}}</h6>
        <input
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          [id]="'sliderinput' + index"
          (change)="onInputChange($event)">
        </div>
        <div class="custom-slider__control" [id]="'slider' + index"></div>
      </div>
    }


